import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Typography,
  Grid,
  Button,
  FormControlLabel,
  RadioGroup,
  Radio,
  TextField,
} from "@mui/material";
import {
  getUserById,
  getUserEarnings,
  getLedger,
  getServiceProviderBookings,
  payment,
  updateLedger,
} from "../apis";
import moment from "moment";

const MyEarnings = () => {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  const [earningsData, setEarningsData] = useState([]);
  const [totalEarning, setTotalEarning] = useState(0);
  const [thisMonthEarning, setThisMonthEarning] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [workInProgress, setWorkInProgress] = useState(0);
  const [stage, setStage] = useState(1);
  const [amountType, setAmountType] = useState("");
  const [enteredAmount, setEnteredAmount] = useState("");
  const [error, setError] = useState(false);

  let user = {};
  user = JSON.parse(localStorage.getItem("user-info"));
  let userID = user.googleId ? user.googleId : user._id;
  useEffect(() => {
    const fetchData = async () => {
      let total = 0;
      let thismonth = 0;
      let d = new Date();
      let month = d.getMonth();
      const response = await getUserById(userID);
      const earningsResult = await getUserEarnings(userID);
      setUserInfo(response.data.serviceProviderInfo);
      setEarningsData(earningsResult.data.earningsData);
      const res = await getLedger(userID);
      setAvailableBalance(res.data.totalAmount);
      earningsResult.data.earningsData.map((item) => {
        total = total + item.earning;
      });
      setTotalEarning(total);

      const filteredData = earningsResult.data.earningsData.filter(
        (item) => moment(item.createdAt).utc().format("MM") == month + 1
      );
      filteredData.map((item) => {
        thismonth = thismonth + item.earning;
      });
      setThisMonthEarning(thismonth);
      const bookings = await getServiceProviderBookings(userID);
      let progress = 0;
      bookings.data.activeRequests.map((item) => {
        progress = progress + parseInt(item.bid.price);
      });
      // setActiveData(bookings.data.activeRequests);
      setWorkInProgress(progress);
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleAmountType = (e) => setAmountType(e.target.value);

  const getPaidButtonHandler = async () => {
    if (amountType == "Other Amount") {
      if (parseInt(enteredAmount) > parseInt(availableBalance)) {
        setError(true);
      } else {
        await payment({ amount: enteredAmount, serviceProviderId: userID });
        const response = await updateLedger({
          id: userID,
          amount: enteredAmount,
          type: "sub",
        });
        setStage(1);
        const res = await getLedger(userID);
        setAvailableBalance(res.data.totalAmount);
        setError(false);
      }
    } else {
      await payment({ amount: availableBalance, serviceProviderId: userID });
      const response = await updateLedger({
        id: userID,
        amount: availableBalance,
        type: "sub",
      });
      setStage(1);
      const res = await getLedger(userID);
      setAvailableBalance(res.data.totalAmount);
      setError(false);
    }
  };

  return (
    <>
      <Navbar />
      {loading ? (
        <Box
          sx={{ display: "flex" }}
          justifyContent="center"
          alignItems="center"
          style={{ height: "80vh" }}
        >
          <CircularProgress disableShrink />
        </Box>
      ) : (
        <>
          {stage == 1 ? (
            <Container>
              <Stack
                direction="row"
                spacing={3}
                alignItems="center"
                className="mt-5"
              >
                <div
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "100%",
                    border: "1px solid white",
                  }}
                >
                  <img
                    src={userInfo.personalInfo.image[0]}
                    alt="profile picture"
                    style={{
                      height: "100px",
                      width: "100px",
                      objectFit: "contain",
                      borderRadius: "50%",
                    }}
                  />
                </div>
                <Stack spacing={2}>
                  <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {user.fullName}
                  </Typography>
                  <Typography className="ammanat-darker-gray">
                    {user.email}
                  </Typography>
                </Stack>
              </Stack>

              <Stack spacing={2} className="mt-16">
                <Typography
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                  className="mt-10"
                >
                  Description
                </Typography>
                <Typography className="ammanat-darker-gray">
                  {userInfo.personalInfo.description}
                </Typography>
              </Stack>

              <Grid
                container
                className="mt-16 mb-16"
                style={{
                  padding: "20px",
                  border: "1px solid #CCC9CF",
                  borderRadius: "10px",
                }}
              >
                <Grid item xs={12} sm={12} md={3}>
                  <Stack spacing={2}>
                    <Typography className="mt-10 ammanat-darker-gray">
                      Available Balance
                    </Typography>
                    <Typography
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      £{availableBalance}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Stack spacing={2}>
                    <Typography className="mt-10 ammanat-darker-gray">
                      This Month's Earning
                    </Typography>
                    <Typography
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      £{thisMonthEarning}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  {" "}
                  <Stack spacing={2}>
                    <Typography className="mt-10 ammanat-darker-gray">
                      Total Earnings
                    </Typography>
                    <Typography
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      £{totalEarning}
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  {" "}
                  <Stack spacing={2}>
                    <Typography className="mt-10 ammanat-darker-gray">
                      Work in Progress
                    </Typography>
                    <Typography
                      style={{ fontSize: "20px", fontWeight: "bold" }}
                    >
                      £{workInProgress}
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={() => setStage(2)}
              >
                Get Paid Now
              </Button>
            </Container>
          ) : (
            <Container>
              {error ? (
                <Typography style={{ color: "red" }}>
                  Entered Amount must be less than available balance
                </Typography>
              ) : (
                <></>
              )}
              <Typography
                style={{ fontSize: "20px", fontWeight: "bold" }}
                className="mt-16 mb-16"
              >
                Get Paid Now
              </Typography>
              <Typography
                style={{ fontSize: "16px", fontWeight: "600" }}
                className="mt-16"
              >
                Available Balance
              </Typography>
              <Typography
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "#7A7A80",
                }}
                className="mb-16"
              >
                £{availableBalance}
              </Typography>
              <Typography
                style={{ fontSize: "16px", fontWeight: "600" }}
                className="mt-16 mb-10"
              >
                Amount
              </Typography>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={amountType}
                onChange={handleAmountType}
              >
                <div
                  style={
                    amountType == "Other Amount"
                      ? {
                          border: "1px solid rgba(122, 122, 128, 0.5)",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          marginRight: "25px",
                        }
                      : {
                          border: "1px solid #0741C4",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          marginRight: "25px",
                        }
                  }
                >
                  <FormControlLabel
                    value={availableBalance}
                    control={<Radio />}
                    label={`£${availableBalance}`}
                  />
                </div>
                <div
                  style={
                    amountType == "Other Amount"
                      ? {
                          border: "1px solid #0741C4",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          marginRight: "25px",
                        }
                      : {
                          border: "1px solid rgba(122, 122, 128, 0.5)",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "10px",
                          marginRight: "25px",
                        }
                  }
                >
                  <FormControlLabel
                    value="Other Amount"
                    control={<Radio />}
                    label="Other Amount"
                  />
                </div>
              </RadioGroup>

              <Typography
                style={{ fontSize: "16px", fontWeight: "600" }}
                className="mt-16"
              >
                Enter Amount
              </Typography>
              <TextField
                placeholder="Enter Amount"
                disabled={amountType == "Other Amount" ? false : true}
                size="small"
                variant="outlined"
                type="number"
                className="mb-16"
                value={enteredAmount}
                onChange={(e) => setEnteredAmount(e.target.value)}
                style={{ borderRadius: "10px" }}
              />
              <Stack
                className="mt-16"
                direction="row"
                spacing={3}
                alignitems="center"
              >
                <Button
                  variant="outlined"
                  className="default-border default-color"
                  style={{ textTransform: "capitalize" }}
                  onClick={() => setStage(1)}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  className="primary-button"
                  style={{ textTransform: "capitalize" }}
                  onClick={getPaidButtonHandler}
                >
                  Get Paid Now
                </Button>
              </Stack>
            </Container>
          )}
        </>
      )}
    </>
  );
};

export default MyEarnings;
